<template>
  <div class="bbp-table-no-data">
    <img :src="imageNoData" class="bbp-table-no-data__img"/>
    <h3 class="bbp-table-no-data__title">No Data</h3>
    <p class="bbp-table-no-data__explanation" v-if="description">{{description}}</p>
  </div>
</template>

<script>
import imageNoData from '@/assets/images/no-data.png'

export default {
  name: 'BBPTableNoData',
  props: ['description'],
  data () {
    return {
      imageNoData: imageNoData
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-table-no-data {
    @include global-font;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 35px;
    padding-top: 45px;

    &__img {
      width: 328px;
      object-fit: cover;
      margin-bottom: 15px;
    }

    &__title {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: $color-accent;
      margin-bottom: 5px;
    }

    &__explanation {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: $color-silver;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTableNoData/BBPTableNoData.vue